module.exports = __webpack_public_path__ + "img/Rectangulo_13.c4c4d8c4.jpg";